module.exports = __webpack_public_path__ + "media/images/games/fifa-21/hiw-4-8ad605f1c04ee062180f8732630d339a.jpg";